module.exports = __webpack_public_path__ + "img/3.3c6bfdc3.jpg";